/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from "react";

function NewIcon({ width = 16, height = 16, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M7.24209 8.75833H3.95659C3.74378 8.75833 3.56419 8.68514 3.41781 8.53876C3.27143 8.39239 3.19824 8.2128 3.19824 8C3.19824 7.7872 3.27143 7.60761 3.41781 7.46123C3.56419 7.31485 3.74378 7.24166 3.95659 7.24166H7.24209V3.95616C7.24209 3.74335 7.31528 3.56376 7.46166 3.41738C7.60804 3.271 7.78763 3.19781 8.00043 3.19781C8.21323 3.19781 8.39281 3.271 8.53919 3.41738C8.68557 3.56376 8.75876 3.74335 8.75876 3.95616V7.24166H12.0443C12.2571 7.24166 12.4367 7.31485 12.583 7.46123C12.7294 7.60761 12.8026 7.7872 12.8026 8C12.8026 8.2128 12.7294 8.39239 12.583 8.53876C12.4367 8.68514 12.2571 8.75833 12.0443 8.75833H8.75876V12.0438C8.75876 12.2566 8.68557 12.4362 8.53919 12.5826C8.39281 12.729 8.21323 12.8022 8.00043 12.8022C7.78763 12.8022 7.60804 12.729 7.46166 12.5826C7.31528 12.4362 7.24209 12.2566 7.24209 12.0438V8.75833Z"
        fill="#484848"
      />
    </svg>
  );
}

export default NewIcon;
